import { createErrorHandlerWithPackageContext } from '@atlaskit/teams-client/create-error-handler-with-package-context';
import { logErrorMessageWithPackageContext } from '@atlaskit/teams-client/log-error-message-with-package-context';
import { logExceptionWithPackageContext } from '@atlaskit/teams-client/log-exception-with-package-context';
import { logInfoMessageWithPackageContext } from '@atlaskit/teams-client/log-info-message-with-package-context';
import type { CreateErrorHandler } from '@atlaskit/teams-client/sentry/types';

const packageContext = {
	packageName: process.env._PACKAGE_NAME_ as string,
	packageVersion: process.env._PACKAGE_VERSION_ as string,
};

export const logException: (ex: unknown, name: string, context?: any) => void =
	logExceptionWithPackageContext(packageContext);
export const logErrorMessage: (message: string, context?: any) => void =
	logErrorMessageWithPackageContext(packageContext);
export const logInfoMessage: (message: string, context?: any) => void =
	logInfoMessageWithPackageContext(packageContext);
export const createErrorHandler: CreateErrorHandler =
	createErrorHandlerWithPackageContext(packageContext);
